import { useEffect, useState } from "react";
import { getMethod } from "../modules/helper";

const useProvince = ({ initiate = false, id = undefined }) => {
  const [provinces, setProvinces] = useState([]);
  const [province, setProvince] = useState([]);

  const get = () => {
    return new Promise(async resolve => {
      const response = await getMethod("/address/v1/province");

      if (response.status === 200) {
        resolve(response.data.result);
      }
    });
  };

  const getById = () => {
    return new Promise(async resolve => {
      const response = await getMethod("/address/v1/province/show/" + id);

      if (response.status === 200) {
        resolve(response.data.data);
      }
    });
  };

  useEffect(() => {
    if (initiate === true) {
      get().then(res => setProvinces(res));
    }
  }, []);

  useEffect(() => {
    if (id) {
      getById().then(setProvince);
    }
  }, []);

  return { get, provinces, province, getById };
};

export default useProvince;
